import React from 'react'
import { Text } from '@leverege/ui-elements'

function LinePill( props ) {
  const { number } = props
  return (
    <Text
      icon="fa-kit fa-lv-profile"
      variant="linePerformancePill">
      {number}
    </Text>
  )
}

export default LinePill
